import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InteractionApiService} from "../../api/interaction-api.service";
import {UserInteractionTypeDto} from "../../types/ds-interaction.types";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {InteractionService} from "../../service/interaction.service";


@Component({
  selector: 'app-interaction-types',
  templateUrl: './interaction-types.component.html',
  styleUrls:['interaction-types.component.scss']
})
export class InteractionTypesComponent extends CoreComponent implements OnInit {

  interactionTypes?: UserInteractionTypeDto[];
  hoverId: number | null = null;

  constructor(
    protected interactionApiService: InteractionApiService,
    protected interactionService: InteractionService,
    protected  router: Router) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.refreshComponent();
  }

  handleInteractTypeSelect(interactionType: UserInteractionTypeDto) {

    let firstStep = this.interactionService.getFirstStep(interactionType);

    if (firstStep) {
      this.router.navigate([`/ci/service/${interactionType.id}/${firstStep}`]);
    } else {
      this.router.navigate([`/ci/service/${interactionType.id}`]);
    }


  }


  refreshComponent() {

    // retrieve available interaction types
    this.interactionApiService.getInteractionTypes().subscribe(value => {
      this.interactionTypes = value.interactionTypes;
      this.initialized = true;
    });

  }

  // Method to generate a dynamic gradient based on the index/id
  getGradient(index: number, isHovering : boolean): string {
    const hueStep = 260;
    const hue = (index * hueStep) % 360;

    // Adjust these values for sharper colors on hover
    const saturation = isHovering  ? 65 : 60;
    const lightnessStart = isHovering  ? 94 : 97;
    const lightnessEnd = 99;

    const colorStart = `hsl(${hue}, ${saturation}%, ${lightnessStart}%)`;
    const colorEnd = isHovering  ? `hsl(${hue}, ${saturation}%, ${lightnessEnd}%)` : `hsl(0, 0%, ${lightnessEnd}%)`;

    return `linear-gradient(to right, ${colorStart}, ${colorEnd})`;
  }

}
